//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconStatusStopFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M19.075 4.9325C15.165 1.0225 8.835 1.0225 4.925 4.9325C1.025 8.8325 1.025 15.1725 4.925 19.0725C8.835 22.9825 15.165 22.9825 19.075 19.0725C22.985 15.1725 22.985 8.8325 19.075 4.9325ZM16 8H7.99999V16H16V8Z" fill="currentColor" /></svg>;
}
export default IconStatusStopFill;